import { Action } from '../../../common/actions/core/action';

export class OpenStudentReviewingAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/components/student/reviewing/reviewing.action.ts